export enum PartnerType {
  DEVELOPER = 'developer',
  DEVELOPER_ORGANISATION = 'developer_organisation',
  REAL_ESTATE_OFFICE = 'real_estate_office',
  REAL_ESTATE_OFFICE_ORGANISATION = 'real_estate_office_organisation',
  INTERNET_WEBSITE = 'internet_website',
  OWN_PARTNER_CONTRACT = 'own_partner_contract',
  OTHER = 'other',
}
